import { createBrowserRouter } from 'react-router-dom';

// project imports
import MainRoutes, { OnboardingRoute, PlanSelectionRoute } from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import PublicRoutes from './PublicRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([LoginRoutes, PublicRoutes, OnboardingRoute, PlanSelectionRoute, MainRoutes], { basename: import.meta.env.VITE_APP_BASE_NAME });

export default router;
